import { ServiceType } from 'src/contstant/apiEndpoints';
import { createApiInstance } from './apiInstance';

export const apiClient = {
  get: async <T>(serviceType: ServiceType, url: string, params?: object): Promise<T> => {
    const response = await createApiInstance(serviceType).get<T>(url, { params });
    return response.data;
  },

  post: async <T, U>(
    serviceType: ServiceType,
    url: string,
    data: U,
    config?: { timeout?: number },
  ): Promise<T> => {
    const response = await createApiInstance(serviceType).post<T>(url, data, config);
    return response.data;
  },

  postFormData: async <T>(
    serviceType: ServiceType,
    url: string,
    file: Blob,
    params?: object,
    headers?: object,
  ): Promise<T> => {
    const instance = createApiInstance(serviceType);
    const obj = {
      params,
      headers: headers,
    };
    const response = await instance.post<T>(url, file, obj);

    return response.data;
  },

  put: async <T, U>(serviceType: ServiceType, url: string, data: U): Promise<T> => {
    const response = await createApiInstance(serviceType).put<T>(url, data);
    return response.data;
  },

  delete: async <T>(
    serviceType: ServiceType,
    url: string,
    params?: object,
    deletedBy?: string,
  ): Promise<T> => {
    const response = await createApiInstance(serviceType).delete<T>(url, {
      params: params,
      headers: {
        'X-Deleted-By': deletedBy,
      },
    });
    return response.data;
  },
};
